const initState = {
    scheduleInfo: {},
    isShowSchedulePageReceiveDialog: false,
    isShowSchedulePageQrDialog: false,
    scheduleSignins: [],
}

export default function (state = initState, action) {
    switch (action.type) {
        case 'SET_SCHEDULE_INFO':
            return { ...state, scheduleInfo: action.payload }
        case 'SET_IS_SHOW_SCHEDULE_PAGE_RECEIVE_DIALOG':
            return { ...state, isShowSchedulePageReceiveDialog: action.payload }
        case 'SET_IS_SHOW_SCHEDULE_PAGE_QR_DIALOG':
            return { ...state, isShowSchedulePageQrDialog: action.payload }
        case 'SET_SCHEDULE_PAGE_QR_DIALOG':
            return { ...state, isShowSchedulePageQrDialog: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/schedule.js